module.exports = __webpack_public_path__ + "img/product-01.19ce1af7.svg";